import * as React from 'react';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import PercentView from 'components/PercentView';

interface Props {
  children: number;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

class Profit extends React.Component<Enhanced> {
  render() {
    const { t, children: profit } = this.props;

    if (!profit) {
      return t('Not yet known');
    }

    return (
      <span>
        <PercentView>{profit}</PercentView> {t('annually')}
      </span>
    );
  }
}

export default enhance(Profit);
